<template>
  <div style="min-height: 77.8vh;background:#f8f8f9;">
    <Layout>
      <Sider style="min-width: 200px;">
        <div id="anchorContent">
          <Anchor container=".aaa" show-ink style="margin: 5px;">
            <AnchorLink href="#pcconfig" title="一.电脑及网络配置">
              <AnchorLink href="#pcconfig1" title="1.操作系统" />
              <AnchorLink href="#pcconfig2" title="2.浏览器" />
              <AnchorLink href="#pcconfig3" title="3.系统分辨率" />
              <AnchorLink href="#pcconfig4" title="4.网络" />
            </AnchorLink>
            <AnchorLink href="#SketchMap" title="二.示意图">
              <AnchorLink href="#1" title="1.政策法规示意图" />
              <AnchorLink href="#2" title="2.搜索引擎示意图" />
              <AnchorLink href="#4" title="3.分屏示意图" />
              <AnchorLink href="#8" title="4.检索结果一键上传与选择上传示意图">
                <AnchorLink href="#8" title="4.1.一键上传" />
                <AnchorLink href="#18" title="4.2.选择上传" />
              </AnchorLink>
              <AnchorLink href="#24" title="5.智慧云端示意图" />
              <AnchorLink href="#34" title="6.我的秘书示意图" />
              <AnchorLink href="#36" title="7.在线商城示意图" />
              <AnchorLink href="#44" title="8.具体文件示意图" />
              <AnchorLink href="#54" title="9.个人中心示意图">
                <AnchorLink href="#54" title="9.1.账号中心" />
                <AnchorLink href="#62" title="9.2.更换手机" />
                <AnchorLink href="#64" title="9.3.修改密码" />
                <AnchorLink href="#66" title="9.4.重置密码" />
              </AnchorLink>
            </AnchorLink>
            <AnchorLink href="#worddesc" title="三.专有名词解释">
              <AnchorLink href="#worddesc1" title="1.特定适用对象" />
              <AnchorLink href="#worddesc2" title="2.行业类之二级分类“通用规定”" />
              <AnchorLink href="#worddesc3" title="3.行业类之二级分类“专属规定”" />
              <AnchorLink href="#worddesc4" title="4.税收条约之二级分类“通用规定”" />
              <AnchorLink href="#worddesc5" title="5.税收条约之二级分类“国家（地区）”" />
              <AnchorLink href="#worddesc6" title="6.税收条约具体文件中的特别处理" />
              <AnchorLink href="#worddesc7" title="7.具体文件中的“版本汇总”及“年份标注”" />
              <AnchorLink href="#worddesc8" title="8.税法应用智能化模块" />
              <AnchorLink href="#worddesc9" title="9.智慧云端" />
              <AnchorLink href="#worddesc10" title="10.我的秘书" />
              <AnchorLink href="#worddesc11" title="11.创设文号" />
            </AnchorLink>
            <AnchorLink href="#guide" title="四.特别指引">
            </AnchorLink>
          </Anchor>
        </div>
      </Sider>
      <Layout>
        <Content>
          <div class="aaa">
            <H3 id="pcconfig">一.电脑及网络配置</H3>
            <Divider dashed orientation="left" id="pcconfig1">1.操作系统</Divider>
            <p>推荐配置:Windows® 7 / Windows® 8 / Windows® 10 64位系统(最新版本的Service Pack)</p>
            <p>最低配置:Windows® 7 / Windows® 8 / Windows® 10 64位系统(最新版本的Service Pack)</p>
            <Divider dashed orientation="left" id="pcconfig2">2.浏览器</Divider>
            <p style="line-height: 16px;">推荐浏览器：<img :src=logo+edge class="logo"> <a href="Microsoft-edge:http://www.holywiser.com" target="_blank">Edge(微软Edge浏览器)</a>,<img :src=logo+edge_chrome class="logo"> <a href="https://www.microsoft.com/zh-cn/edge" target="_blank">Edge(新版)</a>,<img :src=logo+chrome class="logo"> <a href="https://www.google.cn/chrome/" target="_blank">Chrome(谷歌浏览器)</a>,<img :src=logo+firefox class="logo"> <a href="https://www.firefox.com.cn/" target="_blank">Firefox(火狐浏览器)</a></p>
            <Divider dashed orientation="left" id="pcconfig3">3.系统分辨率</Divider>
            <p>推荐系统分辨率为:1920*1080</p>
            <p>最低系统分辨率为:1600*900</p>
            <Divider dashed orientation="left" id="pcconfig4">4.网络</Divider>
            <p>宽带网络，无线网络</p>
            <H3 id="SketchMap">二.示意图(点击小图,查阅大图)</H3>
            <Divider dashed orientation="left" id="1">1.政策法规</Divider>
            <div v-for="item in items" :key="item.index" :id="item.index">
              <Card style="width:500px;cursor:pointer;float:left;margin:20px;">
                <div style="text-align:center;" @click="test(item)">
                  <img :src=imgroot+item.imgsrc style="width:450px;">
                  <h3>{{item.title}}</h3>
                </div>
              </Card>
              <Divider dashed :style="{display:item.divider?'inline-table':'none'}" orientation="left">{{item.dividertxt}}</Divider>
              <span :style="{display:item.subtitle!==''?'inline-table':'none'}" style="padding-left: 100px;width:100%;">{{item.subtitle}}</span>
            </div>
            <H3 id="worddesc">三、专有名词解释</H3>
            <div id="desc">
              <p id="worddesc1" class="title">1.特定适用对象:</p>
              <p>归集文件条款含有针对特定对象制发的内容，包括7个二级分类。</p>
              <p id="worddesc2" class="title">2.行业类之二级分类“通用规定”:</p>
              <p>归集文件条款含有针对所有行业制发的内容。</p>
              <p id="worddesc3" class="title">3.行业类之二级分类“专属规定”：</p>
              <p>归集文件条款含有针对特定行业制发的内容。</p>
              <p id="worddesc4" class="title">4.税收条约之二级分类“通用规定”：</p>
              <p>归集文件条款含有针对所有缔约国家（地区）制发的内容。</p>
              <p id="worddesc5" class="title">5.税收条约之二级分类“国家（地区）”：</p>
              <p>归集文件条款含有针对特定缔约国家（地区）制发的内容。</p>
              <p id="worddesc6" class="title">6.税收条约具体文件中的特别处理：</p>
              <h4>6.1.文件名中的“红色括号标注内容”：为便于用户迅速了解文件的签订年度，缔约国家的解体、建国以及相关的延续适用等对文件的适用影响，相应添加。</h4>
              <h4>6.2.部分议定书、换文和换函等的适用基础、适用对象等对用户适用文件有重要支撑，相应添加（红色字体）。</h4>
              <h4>6.3.文件末尾添加的“相关链接”：为便于用户迅速了解文件制发的相关过程，准确适用文件。</h4>
              <p id="worddesc7" class="title">7.具体文件中的“版本汇总”及“年份标注”：</p>
              <h4>7.1.版本汇总：针对部门规章及以上的文件，存在若干次修订的情况下，因文件名相同，为便于用户准确适用，在文件名处添加“红色括号标注版本”，并在文件名之下以三段或两段文字论述最新版本及当前版本变动成因和“版本汇总”链接点，文件末尾设“版本汇总”归集所有版本，首尾呼应；</h4>
              <h4>7.2.年份标注：针对非版本汇总文件，因若干次修改，出现同名情形，在文件名处添加“红色括号标注年份”。</h4>
              <p id="worddesc8" class="title">8.税法应用智能化模块：</p>
              <p>设置法规层级筛选框，用于对相应文件列表内的文件进行精准过滤；“检索结果一键上传”和“检索结果选择上传”，用于对选中文件上传至智慧云端之“上传文件库”。</p>
              <p id="worddesc9" class="title">9.智慧云端：</p>
              <p>暂开放“上传文件库”，用户可在云端文件库管理和适用文件，实现“一次上传，多口径切换选取适用文件”。</p>
              <p id="worddesc10" class="title">10.我的秘书：</p>
              <p>暂开放“云端变动提醒”和“历史查询纪录”，用于及时提醒用户适用文件的效力变动情况，绑定微信公众号后，即时提醒，避免误用文件。</p>
              <p id="worddesc11" class="title">11.创设文号：</p>
              <p>具体文件为附件或政策解读时，页首要素中的文号设计，用于迅速链接主文件。</p>
            </div>
            <H3 id="guide">四、特别指引</H3>
            <div id="guide">
              <p>1.“法规分类”、“查询关键词”、“文件效力”、“时间范围”这四个检索条件可任意组合使用，精准查询。</p>
              <p>2.“法规层级”根据检索结果自动匹配，并可用于对列表内文件精准过滤所需层级的文件；当检索条件改变后，“法规层级”将根据新的检索结果重置，并可重新过滤选择所需层级的文件。</p>
              <p>3.点击多个文件形成电脑屏幕分屏呈现多个文件，当前电脑屏幕最多呈现三屏文件，其余屏隐藏，可通过滚动条拖动相关文件屏；亦可以通过蓝色缩放按钮实现相关区域隐藏与展示操作。</p>
              <p>4.单个文件、最新文件列表文件或检索结果列表文件均支持上传云端。</p>
              <p>5.具体文件内蓝色字体文件均已建立链接。</p>
              <p>6.单个文件、最新文件列表文件或检索结果列表文件均支持上传云端。</p>
              <p>7.具体文件内蓝色字体文件均已建立链接。</p>
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
    <Modal v-model="modal13" footer-hide  :title="viewtitle" :styles="{top: '20px'}" width="90%">
      <div style="width:100%;min-height:600px;"><img :src=imgroot+viewimgsrc style="width:100%;"></div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "usermanual",
  data() {
    return {
      modal13: false,
      imgroot: '/manual/',
      logo:'/manual/logo/',
      edge:'microsoft_edge.png',
      edge_chrome:'edge_chrome.png',
      chrome:'google_chrome.png',
      firefox:'mozilla_firefox.png',
      viewtitle: '',
      viewimgsrc: '',
      // isshowfooter:"false",
      items: [{
          index: 1,
          title: '政策法规示意图一',
          imgsrc: '1.1.jpg',
          divider: true,
          dividertxt: '2.搜索引擎',
          subtitle: '',
        },
        {
          index: 2,
          title: '搜索引擎示意图一',
          imgsrc: '2.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 3,
          title: '搜索引擎示意图二',
          imgsrc: '2.2.jpg',
          divider: true,
          dividertxt: '3.分屏示意图',
          subtitle: '',
        },
        {
          index: 4,
          title: '分屏示意图一',
          imgsrc: '3.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },

        {
          index: 5,
          title: '分屏示意图二',
          imgsrc: '3.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 6,
          title: '分屏示意图三',
          imgsrc: '3.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 7,
          title: '分屏示意图四',
          imgsrc: '3.4.jpg',
          divider: true,
          dividertxt: '4.检索结果一键上传与选择上传示意图',
          subtitle: '4.1.一键上传',
        },
        {
          index: 8,
          title: '一键上传示意图一',
          imgsrc: '4.1.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 9,
          title: '一键上传示意图二',
          imgsrc: '4.1.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 10,
          title: '一键上传示意图三',
          imgsrc: '4.1.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 12,
          title: '一键上传示意图四',
          imgsrc: '4.1.4.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 13,
          title: '一键上传示意图五',
          imgsrc: '4.1.5.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 14,
          title: '一键上传示意图六',
          imgsrc: '4.1.6.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 15,
          title: '一键上传示意图六',
          imgsrc: '4.1.7.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 16,
          title: '一键上传示意图七',
          imgsrc: '4.1.7.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '4.2选择上传',
        },
        {
          index: 18,
          title: '选择上传示意图一',
          imgsrc: '4.2.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 19,
          title: '选择上传示意图二',
          imgsrc: '4.2.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 20,
          title: '选择上传示意图三',
          imgsrc: '4.2.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 21,
          title: '选择上传示意图四',
          imgsrc: '4.2.4.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 22,
          title: '选择上传示意图五',
          imgsrc: '4.2.5.jpg',
          divider: true,
          dividertxt: '5.智慧云端示意图',
          subtitle: '',
        },
        {
          index: 24,
          title: '智慧云端示意图一',
          imgsrc: '5.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 25,
          title: '智慧云端示意图二',
          imgsrc: '5.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 26,
          title: '智慧云端示意图三',
          imgsrc: '5.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 27,
          title: '智慧云端示意图四',
          imgsrc: '5.4.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 28,
          title: '智慧云端示意图五',
          imgsrc: '5.5.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 29,
          title: '智慧云端示意图六',
          imgsrc: '5.6.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 30,
          title: '智慧云端示意图七',
          imgsrc: '5.7.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 31,
          title: '智慧云端示意图八',
          imgsrc: '5.8.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 32,
          title: '智慧云端示意图九',
          imgsrc: '5.9.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 33,
          title: '智慧云端示意图十',
          imgsrc: '5.10.jpg',
          divider: true,
          dividertxt: '6.我的秘书示意图',
          subtitle: '',
        },
        {
          index: 34,
          title: '我的秘书示意图一',
          imgsrc: '6.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 35,
          title: '我的秘书示意图二',
          imgsrc: '6.2.jpg',
          divider: true,
          dividertxt: '7.在线商城示意图',
          subtitle: '',
        },
        {
          index: 36,
          title: '在线商城示意图一',
          imgsrc: '7.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 37,
          title: '在线商城示意图二',
          imgsrc: '7.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 38,
          title: '在线商城示意图三',
          imgsrc: '7.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 39,
          title: '在线商城示意图四',
          imgsrc: '7.4.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 40,
          title: '在线商城示意图五',
          imgsrc: '7.5.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 41,
          title: '在线商城示意图六',
          imgsrc: '7.6.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 42,
          title: '在线商城示意图七',
          imgsrc: '7.7.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 43,
          title: '在线商城示意图八',
          imgsrc: '7.8.jpg',
          divider: true,
          dividertxt: '8.具体文件示意图',
          subtitle: '',
        },
        {
          index: 44,
          title: '具体文件示意图一',
          imgsrc: '8.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 45,
          title: '具体文件示意图二',
          imgsrc: '8.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 46,
          title: '具体文件示意图三',
          imgsrc: '8.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 47,
          title: '具体文件示意图四',
          imgsrc: '8.4.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 48,
          title: '具体文件示意图五',
          imgsrc: '8.5.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 49,
          title: '具体文件示意图六',
          imgsrc: '8.6.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 50,
          title: '具体文件示意图七',
          imgsrc: '8.7.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 51,
          title: '具体文件示意图八',
          imgsrc: '8.8.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 52,
          title: '具体文件示意图九',
          imgsrc: '8.9.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 53,
          title: '具体文件示意图十',
          imgsrc: '8.10.jpg',
          divider: true,
          dividertxt: '9.个人中心示意图',
          subtitle: '1.账号中心',
        },
        {
          index: 54,
          title: '账号中心示意图一',
          imgsrc: '9.1.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 55,
          title: '账号中心示意图二',
          imgsrc: '9.1.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 56,
          title: '账号中心示意图三',
          imgsrc: '9.1.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 57,
          title: '账号中心示意图四',
          imgsrc: '9.1.4.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 58,
          title: '账号中心示意图五',
          imgsrc: '9.1.5.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 59,
          title: '账号中心示意图6',
          imgsrc: '9.1.6.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 60,
          title: '账号中心示意图七',
          imgsrc: '9.1.7.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 61,
          title: '账号中心示意图八',
          imgsrc: '9.1.8.jpg',
          divider: true,
          dividertxt: '',
          subtitle: '2.更换手机',
        },
        {
          index: 62,
          title: '更换手机示意图一',
          imgsrc: '9.2.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 63,
          title: '更换手机示意图二',
          imgsrc: '9.2.2.jpg',
          divider: true,
          dividertxt: '',
          subtitle: '3.修改密码',
        },
        {
          index: 64,
          title: '修改密码示意图一',
          imgsrc: '9.3.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 65,
          title: '修改密码示意图二',
          imgsrc: '9.3.2.jpg',
          divider: true,
          dividertxt: '',
          subtitle: '4.重置密码',
        },
        {
          index: 66,
          title: '重置密码示意图一',
          imgsrc: '9.4.1.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 67,
          title: '重置密码示意图二',
          imgsrc: '9.4.2.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 68,
          title: '重置密码示意图三',
          imgsrc: '9.4.3.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 69,
          title: '重置密码示意图四',
          imgsrc: '9.4.4.jpg',
          divider: false,
          dividertxt: '',
          subtitle: '',
        },
        {
          index: 70,
          title: '重置密码示意图五',
          imgsrc: '9.4.5.jpg',
          divider: true,
          dividertxt: '',
          subtitle: '',
        },
      ]
    }
  },
  methods: {
    test(item) {
      this.viewimgsrc = item.imgsrc
      this.viewtitle = item.title
      this.modal13 = true
    },
    // instance(type) {
    //   const title = '主屏示意图';
    //   const content = '<div style="width:1400px;min-height:600px;"><img src="../../../static/images/manual/1.1.jpg"></div>';
    //   switch (type) {
    //     case 'info':
    //       this.$Modal.info({
    //         title: title,
    //         content: content,
    //         closable: true,
    //         width: 1500,
    //         scrollable: true,
    //         draggable: true,
    //       });
    //       break;
    //     case 'success':
    //       this.$Modal.success({
    //         title: title,
    //         content: content
    //       });
    //       break;
    //     case 'warning':
    //       this.$Modal.warning({
    //         title: title,
    //         content: content
    //       });
    //       break;
    //     case 'error':
    //       this.$Modal.error({
    //         title: title,
    //         content: content
    //       });
    //       break;
    //   }
    // },
  },
  components: {

  }
}

</script>
<style>
#anchorContent .ivu-anchor-link-title {
  width: 130px;
  white-space: normal;
}
/*侧边导航,会撑开中间内容部分的高度，需要和aaa保持同步可以去掉外部的滚动条*/
#anchorContent .ivu-anchor-wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 10px;
  height: 87vh;

}

</style>
<style scoped>
.goodShow {}

/*.goodShow{position: relative;overflow-y: scroll;}*/
.ivu-layout-sider {
  background-color: white;
}

/*.ivu-anchor-wrapper>.ivu-anchor>.ivu-anchor-link {
  display: block;
  width: 120px;
  white-space: normal;
  color: red;
}*/


/*.ivu-anchor-link{
   white-space: normal;
   word-break:break-all;
   word-wrap:break-word;
}*/
h3 {
  padding-left: 50px;
}

p {
  padding-left: 120px;
  font-size: 16px;
  line-height: 30px;
}

#worddesc,
#SketchMap,
#pcconfig,
#guide {
  font-size: 18px;
}

#desc>p {
  padding-left: 80px;
  font-size: 16px;
  line-height: 30px;
}

#desc>.title {
  font-weight: bold;

}

#desc>h4 {
  padding-left: 100px;
  font-size: 16px;
  line-height: 30px;
  font-weight: normal;
}

#guide>p {
  padding-left: 80px;
  font-size: 16px;
  line-height: 30px;
}

.logo{
  height:16px;
  width: 16px;
  vertical-align: text-top;
}
/*中间内容部分滚动条高度控制*/
.aaa {
position: relative;
overflow-y: scroll;
height:88.8vh;
}
</style>
